import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import "../../css/UserQueries.css"; // reuse same CSS
import ContactUsModalView from "../../component/ContactUsModalView";
import LoaderComponent from "../../component/LoaderComponent";
import { useAdminAuth } from "../../component/AdminUserPresent";

const CustomerDetails = () => {
	const [customers, setCustomers] = useState([]);
	const [loader, setLoader] = useState(false);
	const [selectedCustomer, setSelectedCustomer] = useState(null);
	const isAdmin = useAdminAuth();

	useEffect(() => {
		if (!isAdmin) return;
		setLoader(true);
		const db = getDatabase();
		const customerRef = ref(db, "users"); // 🔥 firebase path

		const unsubscribe = onValue(customerRef, (snapshot) => {
			if (snapshot.exists()) {
				const data = snapshot.val();
				const formatted = Object.keys(data).map((key) => ({
					id: key,
					...data[key],
				}));
				setCustomers(formatted.reverse());
			} else {
				setCustomers([]);
			}
			setLoader(false);
		});

		return () => unsubscribe();
	}, []);

	return (
		<div className="user-queries-container">
			{loader && <LoaderComponent />}

			<div className="text-center py-4">
				<h2>Customer Details</h2>
			</div>

			<div className="query-cards py-3">
				{customers.length === 0 && !loader && (
					<p className="text-center">No customers found</p>
				)}

				{customers.map((customer) => (
					<div key={customer.id} className="query-card">
						<p>
							<strong>Name:</strong> {customer.fName}{" "}
							{customer.lName}
						</p>
						<p>
							<strong>Email:</strong> {customer.email}
						</p>
						<p>
							<strong>Phone:</strong> {customer.mobile}
						</p>

						<button
							className="details-btn query-details-btn"
							onClick={() => setSelectedCustomer(customer)}
						>
							Details
						</button>
					</div>
				))}
			</div>

			{/* 🔹 MODAL */}
			<ContactUsModalView
				isOpen={!!selectedCustomer}
				onClose={() => setSelectedCustomer(null)}
			>
				{selectedCustomer && (
					<div className="query-details">
						<h3>Customer Details</h3>

						<div className="query-row">
							<span>Name:</span>
							<span>{selectedCustomer.fName}</span>
							{" "}
							<span>{selectedCustomer.lName}</span>
						</div>

						<div className="query-row">
							<span>Email:</span>
							<span className="break-word">
								{selectedCustomer.email}
							</span>
						</div>

						<div className="query-row">
							<span>Phone:</span>
							<span>{selectedCustomer.mobile}</span>
						</div>

						<div className="query-row">
							<span>Created At:</span>
							<span>
								{selectedCustomer.creationDate
									? new Date(
											selectedCustomer.creationDate,
										).toLocaleString()
									: "-"}
							</span>
						</div>
					</div>
				)}
			</ContactUsModalView>
		</div>
	);
};

export default CustomerDetails;
